export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Los códigos promocionales y las tarjetas de regalo no pueden combinarse con ningún otro descuento. Una oferta y un canje de puntos pueden usarse juntos. Los descuentos automáticos, como el descuento por recogida, siguen aplicándose.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Los códigos promocionales y las tarjetas de regalo no pueden combinarse con ningún otro descuento.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Desbloqueado',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'No se puede combinar con códigos promocionales ni tarjetas de regalo.',
    promo: 'No se puede combinar con ofertas, tarjetas de regalo ni puntos.',
    gift: 'No se puede combinar con ofertas, códigos promocionales ni puntos.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Hay un código promocional aplicado. Aplicar esta oferta lo eliminará.',
    offer_blocked_by_gift: 'Hay una tarjeta de regalo aplicada. Aplicar esta oferta la eliminará.',
    offer_blocked_by_points: 'Hay un canje de puntos activo. Aplicar esta oferta lo eliminará.',
    promo_gift_displaces_offer: 'Aplicar un código promocional o tarjeta de regalo eliminará tu oferta activa.',
    promo_gift_displaces_points: 'Aplicar un código promocional o tarjeta de regalo eliminará tu canje de puntos.',
    promo_gift_displaces_offer_and_points:
      'Aplicar un código promocional o tarjeta de regalo eliminará tu oferta activa y tu canje de puntos.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Este {{kind}} ya está activo: {{name}} ({{saving}}).',
    active_line_no_saving: 'Este {{kind}} ya está activo: {{name}}.',
    candidate_line: 'El {{kind}} ahorra {{saving}}.',
    only_one: 'Solo puedes usar uno.',
    best_choice: 'Mejor opción',
    keep: 'Mantener {{label}}',
    use_instead: 'Usar {{label}} en su lugar',
    kinds: {
      offer: 'oferta',
      promo: 'código promocional',
      gift: 'tarjeta de regalo',
      points: 'canje de puntos',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'oferta',
      promo: 'código',
      gift: 'tarjeta de regalo',
      points: 'puntos',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} ya está activo. Solo se puede usar un descuento por pedido: usa esta oferta o cierra esta ventana para mantener tu código.',
    active_named: {
      promo: 'Código promocional {{name}} ({{saving}})',
      gift: 'Tarjeta de regalo ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Código promocional {{name}}',
      gift: 'Tarjeta de regalo',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Tienes {{count}} ofertas activas: {{first}} ({{firstValue}}) y {{second}} ({{secondValue}}) — {{total}} en total. El código {{code}} ahorra {{codeValue}} en este pedido. Solo se puede usar una.',
    active_offers_more:
      'Tienes {{count}} ofertas activas: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) y {{more}} más — {{total}} en total. El código {{code}} ahorra {{codeValue}} en este pedido. Solo se puede usar una.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Disponible ahora',
    applied: 'Aplicado · {{savings}} de descuento',
    applied_plain: 'Aplicado',
    replaces: 'No se puede combinar con {{label}} · Reemplaza {{name}}',
    replaces_no_name: 'No se puede combinar con {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'No se puede combinar con {{name}}',
    replaces_name: 'Reemplaza {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'No se puede combinar con tus {{count}} ofertas activas',
    replaces_offers: 'Reemplaza {{count}} ofertas activas ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'una oferta',
      promo: 'un código promocional',
      gift: 'una tarjeta de regalo',
      points: 'tu canje de puntos',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} aplicado. Esto eliminó {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Código promocional {{code}} ({{codeValue}}) aplicado. Esto eliminó {{count}} ofertas: {{first}} y {{second}} ({{total}}).',
      gift: 'Tarjeta de regalo aplicada. Esto eliminó {{count}} ofertas: {{first}} y {{second}} ({{total}}).',
    },
    undo: 'Deshacer',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Oferta {{name}}',
      promo: 'Código promocional {{code}}',
      gift: 'Tarjeta de regalo',
      points: '{{count}} puntos',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: 'la oferta {{name}}',
      promo: 'el código promocional {{code}}',
      gift: 'la tarjeta de regalo',
      points: 'tu canje de puntos',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Usar puntos eliminará el código promocional {{name}} (–{{saving}})',
      gift: 'Usar puntos eliminará la tarjeta de regalo (–{{saving}})',
      promo_no_saving: 'Usar puntos eliminará el código promocional {{name}}',
      gift_no_saving: 'Usar puntos eliminará la tarjeta de regalo',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo:
        '{{points}} puntos aplicados (–{{pointsSaving}}). El código promocional {{name}} (–{{couponSaving}}) fue eliminado.',
      gift: '{{points}} puntos aplicados (–{{pointsSaving}}). La tarjeta de regalo (–{{couponSaving}}) fue eliminada.',
      promo_no_saving: '{{points}} puntos aplicados (–{{pointsSaving}}). El código promocional {{name}} fue eliminado.',
      gift_no_saving: '{{points}} puntos aplicados (–{{pointsSaving}}). La tarjeta de regalo fue eliminada.',
    },
  },
};
